import Checkmark from "components/Icons/Checkmark";
import { LIGHT_COLORS } from "components/VTO/VTO.constants";
import { VTOColor } from "components/VTO/VTO.interfaces";
import { FC, useMemo } from "react";

const LensColorSelector = ({ title, colors, selectedColor, updateSelectedColor, onHover, otherProps }:any) => {
    return (
      <div className="flex flex-col text-left z-[2]" {...otherProps}>
        <span className="mb-[6px]">
          {title}
          {!!selectedColor && (
            <>
              ,{' '}
              <span className="ml-[4px] text-brand-grey150">
                {selectedColor.title}
              </span>
            </>
          )}
        </span>
        <div className="flex w-full">
          {colors.map((color:any) => (
            <span key={color.id} className="mr-0.5">
                <ColorCheckbox
                onSelect={(color) => updateSelectedColor?.(color)}
                onHover={(color) => onHover?.(color)}
                selected={selectedColor?.id === color.id}
                color={color}
                />
            </span>
          ))}
        </div>
      </div>
    );
  };
  
  const ColorCheckbox: FC<{
    color: VTOColor;
    selected: boolean;
    onSelect: (color: VTOColor) => void;
    onHover: (color: VTOColor) => void;
  }> = ({ color, selected, onSelect, onHover }) => {
    const isLight = useMemo(() => LIGHT_COLORS.includes(color.id), [color]);
    
    const handleInteraction = (e: React.MouseEvent | React.TouchEvent) => {
      e.preventDefault();
      onSelect(color);
      onHover(color);
    };

    return (
      <span
        className="flex h-[21px] w-[21px] z-10 items-center justify-center rounded-full border transition-transform"
        onClick={handleInteraction}
        onTouchStart={handleInteraction}
        onMouseEnter={() => onHover(color)}
        style={{
          backgroundColor: 'white',
          borderColor: !selected ? '#e2e2e2' : color.hex,
          cursor: 'pointer'
        }}>
        <span
          style={{
            backgroundColor: color.hex
          }}
          className="h-[15px] w-[15px] rounded-full"
        />
      </span>
    );
  };


  export default LensColorSelector;